// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as HealthRouteImport } from './routes/health'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R404RouteImport } from './routes/404'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsTacticalDronesRouteImport } from './routes/products/tactical-drones'
import { Route as ProductsJadeRouteImport } from './routes/products/jade'
import { Route as ProductsChornaRouteImport } from './routes/products/chorna'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocalePrivacyRouteImport } from './routes/$locale/privacy'
import { Route as LocaleCookiesRouteImport } from './routes/$locale/cookies'
import { Route as LocaleAboutRouteImport } from './routes/$locale/about'
import { Route as LocaleProductsTacticalDronesRouteImport } from './routes/$locale/products/tactical-drones'
import { Route as LocaleProductsJadeRouteImport } from './routes/$locale/products/jade'
import { Route as LocaleProductsChornaRouteImport } from './routes/$locale/products/chorna'

const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsTacticalDronesRoute = ProductsTacticalDronesRouteImport.update({
            id: '/products/tactical-drones',path: '/products/tactical-drones',getParentRoute: () => rootRouteImport
          })
const ProductsJadeRoute = ProductsJadeRouteImport.update({
            id: '/products/jade',path: '/products/jade',getParentRoute: () => rootRouteImport
          })
const ProductsChornaRoute = ProductsChornaRouteImport.update({
            id: '/products/chorna',path: '/products/chorna',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocalePrivacyRoute = LocalePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LocaleRoute
          })
const LocaleCookiesRoute = LocaleCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => LocaleRoute
          })
const LocaleAboutRoute = LocaleAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LocaleRoute
          })
const LocaleProductsTacticalDronesRoute = LocaleProductsTacticalDronesRouteImport.update({
            id: '/products/tactical-drones',path: '/products/tactical-drones',getParentRoute: () => LocaleRoute
          })
const LocaleProductsJadeRoute = LocaleProductsJadeRouteImport.update({
            id: '/products/jade',path: '/products/jade',getParentRoute: () => LocaleRoute
          })
const LocaleProductsChornaRoute = LocaleProductsChornaRouteImport.update({
            id: '/products/chorna',path: '/products/chorna',getParentRoute: () => LocaleRoute
          })





const LocaleRouteChildren = {
  LocaleAboutRoute: LocaleAboutRoute,LocaleCookiesRoute: LocaleCookiesRoute,LocalePrivacyRoute: LocalePrivacyRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleProductsChornaRoute: LocaleProductsChornaRoute,LocaleProductsJadeRoute: LocaleProductsJadeRoute,LocaleProductsTacticalDronesRoute: LocaleProductsTacticalDronesRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,LocaleRoute: LocaleRouteWithChildren,R404Route: R404Route,AboutRoute: AboutRoute,CookiesRoute: CookiesRoute,HealthRoute: HealthRoute,PrivacyRoute: PrivacyRoute,ProductsChornaRoute: ProductsChornaRoute,ProductsJadeRoute: ProductsJadeRoute,ProductsTacticalDronesRoute: ProductsTacticalDronesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)